// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Mm7zF","back":"style_back__-YMw7"};